import { ETH_CHAIN_NETWORKS, V3_STAKING_CONTRACT } from '@context/constants';

export const getStakingFarmForPath = (
  path: string,
  farmList: IFarmPair[],
  provider?: string,
  activeTab?: 'v2' | 'v3',
  v2HasPosition?: boolean,
): IFarmPair | undefined => {
  // For verse-btc path on Ethereum networks, prioritize V3 data
  if (
    path === 'verse-btc' &&
    provider &&
    ETH_CHAIN_NETWORKS.includes(provider)
  ) {
    // Priority 1: If V3 tab is selected, use V3 data
    if (activeTab === 'v3') {
      const v3Farm = farmList.find(
        farm =>
          farm.customPath === path &&
          farm.contractAddress === V3_STAKING_CONTRACT,
      );
      if (v3Farm) {
        return v3Farm;
      }
    }

    // Priority 2: If user has no V2 position, use V3 data
    if (v2HasPosition === false) {
      const v3Farm = farmList.find(
        farm =>
          farm.customPath === path &&
          farm.contractAddress === V3_STAKING_CONTRACT,
      );
      if (v3Farm) {
        return v3Farm;
      }
    }
  }

  // Default behavior: find first matching farm
  const matchingFarm = farmList.find(farm => {
    if (farm.customPath) {
      return farm.customPath === path;
    }

    return farm.stakingToken?.abbr?.toLowerCase() === path?.toLowerCase();
  });

  return matchingFarm;
};
